import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import { IFetchVariables } from "@/selfdisclosure.interfaces";

@Module({ namespaced: true, name: "PasswordStore" })
export default class Password extends VuexModule {
    passwords: {[key: string]: string} = {};
    staffMemberId: any = null;

    get getPasswords() {
        return (digitalOrderingId: string) => this.passwords[digitalOrderingId];
    }

    get hasOrderingId() {
        return (digitalOrderingId: string) => Object.keys(this.passwords).includes(digitalOrderingId);
    }

    @Mutation
    setPassword(payload: IFetchVariables) {
        this.passwords[payload.digitalOrderingId] = payload.password;
    }

    @Mutation
    setStaffMemberId(memberId: any) {
        this.staffMemberId = memberId;
    }

    @Mutation
    reset() {
        this.passwords = {};
        this.staffMemberId = null;
    }

}
